// Determine backend URL: first check for explicit env var, otherwise
// use '/api' when in production (frontend and backend share origin) or
// localhost during development.
let API_URL = process.env.REACT_APP_API_URL;

if (!API_URL) {
  if (process.env.NODE_ENV === 'production') {
    // assume the backend is reachable at /api on same host
    API_URL = '/api';
  } else {
    API_URL = 'http://localhost:3002';
  }
}

export default API_URL;
